export default {
  GET_ALL_ITEMS: (state) => state.all_items,
  GET_ITEM_CATEGORIES: (state) => state.item_categories,
  GET_ITEMS: (state) => state.items,
  GET_ITEM_TYPES: (state) => state.item_types,
  GET_ITEM_UOM: (state) => state.item_uom,
  GET_ITEM_BRAND: (state) => state.item_brand,
  GET_ITEM_SIZE: (state) => state.item_size,
  GET_ALL_BUNDLES: (state) => state.all_bundles,
  GET_ITEM_EDIT_INFO: (state) => state.item_edit_info,
  GET_STORE_ITEM: (state) => state.store_item,
  GET_STORE_IMPORT_ITEM: (state) => state.store_import_item,
  GET_STORE_IMPORT_IMAGE: (state) => state.store_import_image,
  GET_UPDATE_IMPORT_ITEM: (state) => state.update_import_item,
  GET_SHOW_ITEM: (state) => state.show_item,
  GET_UPDATE_SELECTED_ITEM: (state) => state.update_selected_item,
  GET_DESTROY_ITEM: (state) => state.destroy_item,
  GET_STORE_ITEM_BUNDLE: (state) => state.store_item_bundle,
  GET_ITEM_BUNDLE: (state) => state.item_bundle,
  GET_UPDATE_ITEM_BUNDLE: (state) => state.update_item_bundle,
  GET_DESTROY_ITEM_BUNDLE: (state) => state.destroy_item_bundle,
  GET_ALL_ITEM_TYPES: (state) => state.all_item_types,
  GET_STORE_ITEM_TYPES: (state) => state.store_item_types,
  GET_SHOW_ITEM_TYPES: (state) => state.show_item_types,
  GET_UPDATE_ITEM_TYPES: (state) => state.update_item_types,
  GET_DESTROY_ITEM_TYPES: (state) => state.destroy_item_types,
  GET_ALL_ITEM_CATEGORIES: (state) => state.all_item_categories,
  GET_STORE_ITEM_CATEGORIES: (state) => state.store_item_categories,
  GET_SHOW_ITEM_CATEGORIES: (state) => state.show_item_categories,
  GET_UPDATE_ITEM_CATEGORIES: (state) => state.update_item_categories,
  GET_DESTROY_ITEM_CATEGORIES: (state) => state.destroy_item_categories,
  GET_ALL_ITEM_UOM: (state) => state.all_item_uom,
  GET_STORE_ITEM_UOM: (state) => state.store_item_uom,
  GET_SHOW_ITEM_UOM: (state) => state.show_item_uom,
  GET_UPDATE_ITEM_UOM: (state) => state.update_item_uom,
  GET_DESTROY_ITEM_UOM: (state) => state.destroy_item_uom,
  GET_ALL_ITEM_BRAND: (state) => state.all_item_brand,
  GET_STORE_ITEM_BRAND: (state) => state.store_item_brand,
  GET_SHOW_ITEM_BRAND: (state) => state.show_item_brand,
  GET_UPDATE_ITEM_BRAND: (state) => state.update_item_brand,
  GET_DESTROY_ITEM_BRAND: (state) => state.destroy_item_brand,
  GET_ALL_ITEM_SIZES: (state) => state.all_item_sizes,
  GET_STORE_ITEM_SIZES: (state) => state.store_item_sizes,
  GET_SHOW_ITEM_SIZES: (state) => state.show_item_sizes,
  GET_UPDATE_ITEM_SIZES: (state) => state.update_item_sizes,
  GET_DESTROY_ITEM_SIZES: (state) => state.destroy_item_sizes,
  GET_ITEM_SUBSTITUTION: (state) => state.item_substitution,
  GET_EXPORT_ITEM_MASTER_TO_EXCEL: (state) => state.export_item_master_to_excel,
  GET_ITEM_TEMPLATE: (state) => state.item_template,
  GET_ITEM_TEMPLATE_SELECTION: (state) => state.item_template_selection,
  GET_ITEM_TEMPLATE_DETAILS: (state) => state.item_template_details,
  GET_SAMPLE: (state) => state.test,
  GET_PARTS_COMPATIBILITY: (state) => state.parts_compatibility,
  GET_ITEM_TEMP_LIST: (state) => state.item_temp_list,
  GET_ITEM_CHANGES: (state) => state.item_changes,
  GET_ITEM_APPROVAL_DIALOG: (state) => state.item_approval_dialog,
  GET_SELECTED_ITEM_TEMP: (state) => state.selected_item_temp,
  GET_CAN_BYPASS_ITEM_APPROVAL: (state) => state.can_bypass_item_approval,
  GET_CAN_APPROVE_ITEM_CHANGES: (state) => state.can_approve_item_changes,
  GET_ITEM_APPROVAL_SETTINGS: (state) => state.item_approval_settings,
};
